import { useSelector } from "react-redux";
import { selectors } from "../../redux/salesAgents";
import ComboBox from "../ComboBox";

const SalesAgentComboBox = ({ onChange, value, ...props }) => {
  const salesAgentsOptions = useSelector(selectors.selectAll);

  return (
    <ComboBox
      fullWidth
      getOptionLabel={(option) => option.name}
      label="Sales Agent"
      options={salesAgentsOptions}
      onChange={onChange}
      renderOption={(props, option) => (
        <li {...{ ...props, key: `SalesAgent-${option.id}` }}>{option.name}</li>
      )}
      value={value}
      {...props}
    />
  );
};
export default SalesAgentComboBox;
